import SEO from '../../components/SEO';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen pt-20 pb-20 px-4">
      <SEO title="Privacy Policy" />
      <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-3xl border border-slate-100 shadow-sm">
        <h1 className="text-3xl font-bold text-blue-900 mb-8">Privacy Policy</h1>
        <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
          <p>Last updated: March 2026</p>
          <p>
            SSS Home Painting ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and disclose your personal information when you use our website.
          </p>
          <h2 className="text-xl font-bold text-blue-900">Information We Collect</h2>
          <p>
            When you use our contact form or call us, we may collect information such as your name, phone number, email address, and physical address for service estimation purposes.
          </p>
          <h2 className="text-xl font-bold text-blue-900">How We Use Your Information</h2>
          <p>
            We use the collected information solely to provide painting services, respond to inquiries, and communicate regarding project updates. We do not sell or share your data with third-party marketing agencies.
          </p>
          <h2 className="text-xl font-bold text-blue-900">Data Security</h2>
          <p>
            We implement reasonable security measures to protect your information. However, no method of transmission over the internet is 100% secure.
          </p>
          <h2 className="text-xl font-bold text-blue-900">Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at +91 80721 27022.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
